<script>
  export default {
    props: {
      links: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<template>
  <nav class="sidebar-nav col--2">
    <ul class="sidebar-nav__list">
      <li
        :key="to"
        class="sidebar-nav__item"
        v-for="({ to, label }) in links"
        >

        <RouterLink
          :to="to"
          v-text="label"
          class="sidebar-nav__item-link"
          active-class="sidebar-nav__item-link--active"
          />
      </li>
    </ul>
  </nav>
</template>

<style lang="scss">
  .sidebar-nav {
    &__list {
      border-radius: 4px;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05);
      background-color: rgba(#FFF, .08);
    }

    &__item {

      &-link {
        opacity: .5;
        display: block;
        line-height: 1;
        font-size: 14px;
        color: #b2b8c5;
        transition: 150ms;
        letter-spacing: .28px;
        padding: 20px 0 20px 16px;

        &:hover {
          opacity: 1;
        }

        &--active {
          opacity: 1;
          color: #b2b8c5;
          background-color: #3e388b;
        }
      }

      &:not(:last-child) {
        border-bottom: 1px solid rgba(#939cac, .15);
      }

      &:first-child & {
        &-link {
          border-radius: 4px 4px 0 0;
        }
      }

      &:last-child & {
        &-link {
          border-radius: 0 0 4px 4px;
        }
      }
    }
  }
</style>
